import { custom } from "@lib/utils/icons";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import type { IconSet } from "vuetify";
import { type I18n, useI18n } from "vue-i18n";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("vuetify:before-create", ({ vuetifyOptions }) => {
    if (import.meta.client) {
      vuetifyOptions.icons = {
        ...(vuetifyOptions.icons ?? {}),
        sets: {
          ...vuetifyOptions.icons?.sets,
          n: custom as IconSet,
        },
      };
      vuetifyOptions.locale = {
        adapter: createVueI18nAdapter({
          i18n: {
            global: nuxtApp.$i18n,
          } as I18n,
          useI18n,
        }),
      };
    }
  });
});
